import React from 'react'

export default () => (
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <g id="7-9" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RM---answer-autogen-question" transform="translate(-308.000000, -1201.000000)">
                <g id="ic-format-italic-18px" transform="translate(305.000000, 1199.000000)">
                    <polygon id="Path" fill="#56565A" fillRule="nonzero" points="8.16666667 2.33333333 8.16666667 4.66666667 11.1766667 4.66666667 6.90666667 14 3.5 14 3.5 16.3333333 12.8333333 16.3333333 12.8333333 14 9.82333333 14 14.0933333 4.66666667 17.5 4.66666667 17.5 2.33333333"></polygon>
                    <polygon id="Path" points="0 0 21 0 21 21 0 21"></polygon>
                </g>
            </g>
        </g>
    </svg>
)
